import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { getActiveCooperativaId } from '../cooperativa/active-cooperativa.storage';
import { AuthService } from './auth.service';

/**
 * Exige cooperativa activa en sesión (`localStorage`). Si no hay, redirige según rol.
 */
export const tenantWorkspaceGuard: CanActivateFn = async () => {
  if (getActiveCooperativaId()) return true;
  const router = inject(Router);
  const auth = inject(AuthService);
  const isRoot = await auth.isRoot();
  await router.navigate(isRoot ? ['/admin', 'dashboard'] : ['/home']);
  return false;
};
